import type { FaireProductEntity } from "../../entity_types/product";

export const p_y7pj2txxsh: FaireProductEntity = {
  token: "p_y7pj2txxsh",
  type: "product",
  name: "Retro Rainbow Little Pouch",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/7577ca860bb6c94a8e5b1b57401bef6deb1970ccb97690d24f7a738b72e0cab7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a93c2d5f83e000c2e529a90e8625f56452882e4865ef1a2dadd90fc5ac9b6926.jpeg",
    "https://cdn.faire.com/fastly/08564e6320252fceab629e44fb48f4118626cc946b3de7f1d346e47c1705d96c.jpeg",
    "https://cdn.faire.com/fastly/8afceac9975268471b0ffd45c290b30fafd9cb6db79d54ce5819fcf8b77c56c3.jpeg",
    "https://cdn.faire.com/fastly/84453b364b7103a3d0082a3f7cc28a0efd41590dfa5aa9a1aa18de1067c39e3d.png"
  ],
  priceDollars: 8,
  description: "What other little product balances both “love” and “need” so perfectly? A pouch! Just the right size for all the small things that roam free in your bag, these charming zips make organizing a treat. And, with designs that coordinate beautifully with Little Notes® and other E. Frances favorites, they’re also perfect for gifting.\n\nEach pouch comfortably fits 2 packs of Little Notes® plus a set of Little Colored Pencils, making it a must-have for your Little Notes® collection.\n\nMeasuring 7\" x 5\" with a bottom gusset, matte gold zipper and pull, brilliant color and high-quality stitching—these are NICE!",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:52.694Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
